<template>
    <div>
        <table class="table-bordered">
            <tbody>
            <tr>
                <th class="day-header">Technician</th>
                <th class="day-header" style="min-width: 315px !important; text-align: center" v-for="day in days"
                    :key="day" v-html="formatHeaderData(day)"></th>
            </tr>
            <tr v-if="loading">
                <th :colspan="days.length + 1"> Loading events...  <span class="fa fa-sync fa-spin"></span></th>
            </tr>
            <template v-for="([key, value], indexDeparment) in departments">
                <tr>
                    <th class="fixed-column" style="text-align: left; font-size: 0.8em">
                        {{
                            key.substring(2)
                        }}

                        <span @click="setCollapseKey(key)" style="position: absolute; right: 2px; top: 2px; cursor: pointer" class="fa" :class="{'fa-chevron-up':!deparmentCollapsed[key], 'fa-chevron-down':deparmentCollapsed[key]}"></span>

                    </th>

                    <th :colspan="days.length " style="text-align: left; font-size: 0.8em; background: #DDDDDD">{{

                        }}
                    </th>

                </tr>
                <template v-if="!deparmentCollapsed[key]" v-for="(staff, indexStaff) in value">
                    <tr>
                        <td class="fixed-column" style="cursor: pointer; border: 1px solid"
                            @click="staffView(staff.id)">{{
                                staff.title
                            }}
                        </td>
                        <td v-for="day in days" :key="day" @dblclick.self="createSchedule(staff.id, day)">
                            <div class="fc-event-title" v-for="resource in resources.get(`${staff.id}-${day}`)"
                                 @click.prevent.stop="openEvent(resource.id, resource.deleted_at)"
                                 :style="{backgroundColor: resource.backgroundColor, color: resource.textColor, borderColor:resource.borderColor}">
                        <span
                            class="float-right">
                                <span v-if="resource.hours && (((resource.hours - resource.total_hours) * 100) /resource.hours) < -10">**</span>
                                {{ resource.hours }} {{ resource.labor_rate }}</span>&nbsp;
                                {{ resource.start  | formatHour }}
                                &nbsp;&nbsp;
                                <span class="m-letter"><span
                                    v-if="['A','SA','Q','M'].includes(resource.frequency)">({{
                                        resource.frequency
                                    }})</span></span>
                                <span v-if="resource.D" class="m-letter">D</span>
                                <span v-if="resource.C" class="m-letter">C</span>
                                <span v-if="resource.BF" class="m-letter">BFP</span>
                                <span class="m-letter">{{ resource.letter }}</span> - {{ resource.title }} &nbsp;&nbsp;{{
                                    resource.ticket_number
                                }}

                                <div class="custom-popover"
                                     :style="{backgroundColor:resource.backgroundColor, color:resource.textColor, borderColor:resource.borderColor}">
                                    <div>
                                        <small style="text-align:left; margin: 1px" class="tooltiptext">
                                            <strong style="margin-left: -3px;">Scheduler Category:</strong>
                                            {{ resource.schedule_description_category || '' }}<br>
                                            <strong>Creator:</strong>
                                            {{ resource.creator || '' }}<br>
                                            <strong>Start Time - End Time:</strong>
                                            {{ resource.start | dateTimeUs }} - {{ resource.end | dateTimeUs }}<br>
                                            <strong>Techs:</strong>
                                            {{ resource.techs || '' }}<br>
                                            <strong>Scope of Work:</strong><span
                                            v-html="resource.scope_of_work || ''"></span><br>
                                        </small>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
            </template>
            </tbody>

        </table>
        <schedule-staff-view ref="staffView"></schedule-staff-view>
        <schedule-not-confirmed ref="scheduleNotConfirmed"></schedule-not-confirmed>
    </div>
</template>
<script>
import ScheduleStaffView from "./ScheduleStaffView.vue";
import ScheduleNotConfirmed from "./ScheduleNotConfirmed.vue";

export default {
    components: {ScheduleNotConfirmed, ScheduleStaffView},
    props: ['filters'],
    data() {
        return {
            loading: false,
            departments: [],
            deparmentCollapsed: {},
            resources: [],
            startDate: null,
            endDate: null,
            dataForDays: {},
            indexLoopStaff: 0,
            teams: []
        }
    },
    filters: {
        formatHour: function (value) {
            if (!value) return '';

            const partes = value.split(' ');
            if (partes.length === 2) {
                return partes[1].slice(0, 5);
            } else {
                return '';
            }
        }
    },
    created() {
        this.setDatesByWeeks(7)

    },
    async mounted() {
        this.teams = await JSON.parse(sessionStorage.getItem('rams_teams'));

    },
    computed: {
        days() {
            const days = [];
            let currentDay = new Date(this.startDate);
            currentDay.setDate(currentDay.getDate() + 1);

            let endDateRange = new Date(this.endDate);
            endDateRange.setDate(endDateRange.getDate() + 1);

            while (currentDay <= endDateRange) {
                days.push(this.formatDate(currentDay));
                currentDay.setDate(currentDay.getDate() + 1);
            }
            return days;
        },
    },
    methods: {
        setCollapseKey(key){
            this.deparmentCollapsed[key] = !this.deparmentCollapsed[key]
            this.$forceUpdate()
        },
        getDataCalendar() {
            this.loading = true;
            axios.post('/schedules/callendar-data', {
                startWeek: this.startDate, endWeek: this.endDate, teams: this.teams,
                ...this.filters
            }).then((e) => {
                const data = e.data.data

                //staff group
                const groups = new Map();
                data.staff.forEach(obj => {
                    const departament = obj.department;
                    if (!groups.has(departament)) {
                        groups.set(departament, []);
                    }
                    groups.get(departament).push(obj);
                });

                this.departments = groups;
                this.deparmentCollapsed = {};

                [...this.departments].forEach(([key, value]) => {
                    this.deparmentCollapsed[key] = false
                });

                //Resources
                const groupResource = new Map();

                data.resources.forEach(obj => {
                    const col1 = obj.resourceId;
                    const col2 = this.formatDate(new Date(obj.start));
                    const key = `${col1}-${col2}`;

                    if (!groupResource.has(key)) {
                        groupResource.set(key, []);
                    }
                    groupResource.get(key).push(obj);
                });

                this.resources = groupResource

            }).finally((e) => this.loading = false)
        },
        createSchedule(staffId, inputDate) {
            $('#app-preloader').show()
            let app = this;
            app.loading = true;
            console.log('Starting', new Date());
            axios.post('/schedules', {
                date: inputDate, tech: staffId
            }).then((e) => {
                console.log('Open Popup', new Date());
                app.openEvent(e.data.data.id)
                app.getDataCalendar()

            }).finally((e) =>   $('#app-preloader').hide())

        },
        openEvent(id, ghost = null) {
            if (ghost) {
                let app = this;
                Swal.fire({
                    title: 'Ghost Event #' + id,
                    text: "Do you want to restore this deleted Schedule Event?",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonClass: 'btn btn-success',
                    cancelButtonClass: 'btn btn-danger',
                    confirmButtonText: 'Yes, Undelete',
                    buttonsStyling: false
                }).then((result) => {
                    //debugger;
                    if (result.value) {
                        $.ajax({
                            url: "/schedules/" + id + '/undelete',
                            method: "POST",
                            data: {schedule_id: id}
                        }).done(function (data) {
                            showMessage('s', "Restore Deleted Schedule Event");
                            setTimeout(function () {
                                popupwindow('/schedules/iframe/' + id);
                            }, 500)
                            app.getDataCalendar()
                        })
                            .error(function (data) {
                                showMessage('e', "The Schedule Event was not restored");
                            });
                    }

                })
            } else {
                popupwindow('/schedules' + '/iframe/' + id);
            }
        },
        staffView(id) {
            this.$refs.staffView.staff_id = id;
            this.$refs.staffView.getStaff();
        },
        showNotConfirmed() {
            this.$refs.scheduleNotConfirmed.getEvents();
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        formatHeaderData(inputDate) {
            const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

            const dateParts = inputDate.split("-");
            const year = parseInt(dateParts[0]);
            const monthIndex = parseInt(dateParts[1]) - 1;
            const day = parseInt(dateParts[2]);

            const date = new Date(year, monthIndex, day);
            const dayOfWeek = daysOfWeek[date.getDay()];
            const month = months[date.getMonth()];

            return `${dayOfWeek} <br> ${month} ${String(day).padStart(2, '0')}`;
        },
        setDefaultPeriod(period) {
            if (period === 'current_month') {
                const currentDate = new Date();
                const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
                const endOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

                this.startDate = this.formatDate(startOfMonth);
                this.endDate = this.formatDate(endOfMonth);

                if (this.filters.hasOwnProperty('date')) {
                    let date = this.filters.date;

                    if (date.hasOwnProperty('start')) {
                        this.startDate = date.start;
                    }
                    if (date.hasOwnProperty('end')) {
                        this.endDate = date.end;
                    }
                }

            } else {
                let weekDays = 7;
                switch (period) {
                    case '2 weeks':
                        weekDays = 14
                        break;
                    case '3 weeks':
                        weekDays = 21
                        break;
                    case 'month':
                        weekDays = 30
                        break;

                }
                this.setDatesByWeeks(weekDays)
            }
            this.getDataCalendar()
        },
        setDatesByWeeks(weekDays) {
            const currentDate = new Date();
            const startOfWeek = new Date(currentDate);
            const endOfWeek = new Date(currentDate);
            startOfWeek.setDate(currentDate.getDate());
            endOfWeek.setDate(currentDate.getDate() + weekDays);

            this.startDate = this.formatDate(startOfWeek);
            this.endDate = this.formatDate(endOfWeek);

            if (this.filters.hasOwnProperty('date')) {
                let date = this.filters.date;

                if (date.hasOwnProperty('start')) {
                    this.startDate = date.start
                }

                if (date.hasOwnProperty('end')) {
                    this.endDate = date.end
                }


                if (date.hasOwnProperty('operator')) {
                    if (date.operator === '>'){
                        this.startDate = date.value;
                    }
                }

                if (date.hasOwnProperty('operator')) {
                    if (date.operator === '<'){
                        this.startDate = null;
                        this.endDate = date.value;
                    }
                }

            }
        }

    }
}
</script>
<style scoped>
.m-letter {
    margin-right: 2px;
}

.custom-popover {
    display: none;
    position: absolute;
    background-color: #fff;
    border: 1px solid #ccc;
    padding: 5px;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
    z-index: 1000;
}

.fixed-column {
    position: sticky;
    left: 1px;
    font-size: 1em;
    z-index: 1;
    text-align: center;
    background: #DDDDDD;
    border: 1px solid #0a0302;
    border-collapse: collapse;
    background-clip: padding-box;
}


th, td {
    padding-top: 7px;
    padding-bottom: 7px;
    padding-right: 2px;
    border: 1px solid #0a0302;
}

td.fixed-column {
    border: 1px solid #0a0302 !important;
}


tbody {
    /*  display: block;
      overflow-y: auto;
      max-height: 80vh;
      max-width: 100vw;
      scrollbar-width:thin;*/
    max-width: 100vw;
    scrollbar-color: #888 #f5f5f5;
}

.day-header {
    position: sticky;
    top: 0;
    background-color: #DDDDDD;
    z-index: 2;
    box-shadow: inset 0 1px 0 #000000, inset 0 -1px 0 #000000;
}


tbody::-webkit-scrollbar {
    width: 8px !important;
}

tbody::-webkit-scrollbar-thumb {
    background-color: #888;
}

tbody::-webkit-scrollbar-track {
    background-color: #f5f5f5;
}

.fc-event-title {
    margin: 1px !important;
    padding: 1px !important;
    white-space: normal !important;
    width: 100% !important;
    border: 1px solid;
    cursor: pointer;
}

.fc-event-title:hover .custom-popover {
    display: block;
    width: 210px;
}

.fc-event-time {
    margin: 1px !important;
    padding: 1px !important;
    white-space: normal !important;
    font-size: .5em !important;
    width: 2.3em !important;
}

.fc-event {
    font-size: 8px !important;
    line-height: 1.0 !important;
}

.fc-timeline-event {
    position: unset !important;
    padding: 0px 1px !important;;

}
</style>
